import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { useCallback, useState } from "react";
import WizardSelectedExercisesItemTemplate from "./wizardSelectedExercisesItemTemplate";
import ExerciseEditSection from "./exerciseEditSection";

const Step4 = ({
  step,
  selectedPatient,
  selectedExercises,
  setSelectedExercises,
  handleDelete,
  handleCarePlanName,
  dateOfEnd,
  dateOfStart,
  handleDateOfStart,
  handleDateOfEnd,
  carePlanName,
  handleApprovePrescription,
  isPendingAddPlan,
  setExerciseVideoDialogVisible,
  setSelectedExerciseForVideo,
  isEditModeActive,
  setIsEditModeActive,
  editedExercises,
  setEditedExercises,
  isCollapsedDetails,
  setIsCollapsedDetails,
  t,
}: any) => {
  const [selectedExercise, setSelectedExercise] = useState<any>(null);
  const [tempEditedExercises, setTempEditedExercises] = useState<any[]>(editedExercises || []);

  const handleSaveEdit = () => {
    setSelectedExercises(tempEditedExercises);
    setEditedExercises(tempEditedExercises);
    setIsEditModeActive(false);
    setIsCollapsedDetails(false);
    setSelectedExercise(null);
  };

  const moveCard = useCallback(
    (dragIndex: number, hoverIndex: number) => {
      if(isEditModeActive) return;
      setSelectedExercises((prev: any) => {
        const newExerciseProcedure = [...prev];
        const [movedItem] = newExerciseProcedure.splice(dragIndex, 1);
        newExerciseProcedure.splice(hoverIndex, 0, movedItem);
        return newExerciseProcedure;
      });
      setEditedExercises((prev: any) => {
        const newExerciseProcedure = [...prev];
        const [movedItem] = newExerciseProcedure.splice(dragIndex, 1);
        newExerciseProcedure.splice(hoverIndex, 0, movedItem);
        return newExerciseProcedure;
      });
    },
    [setSelectedExercises, setEditedExercises, isEditModeActive]
  );

  return (
    <div
      style={{
        flex: step === 4 ? "0 1 64%" : "0 0 0%",
        backgroundColor: step === 4 ? "#D4DDFF" : "#E8EDFF",
        borderRadius: "16px",
        paddingLeft: step === 4 ? "1.5rem" : "0",
        paddingTop: step === 4 ? "0.5rem" : "0",
        paddingRight: step === 4 ? "1.5rem" : "0",
        paddingBottom: step === 4 ? "1rem" : "0",
        position: "relative",
        height: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        transition:
          "flex 0.4s ease-in-out, background-color 0.4s ease-in-out, padding 0.4s ease-in-out",
        minWidth: 0,
        boxSizing: "border-box",
      }}
    >
      {step === 4 && (
        <>
          <div
            className="flex flex-column"
            style={{ flex: 1, minHeight: 0, overflow: "auto" }}
          >
            <div className="flex flex-column w-full">
              <div className="flex justify-content-between align-items-center">
                <span
                  className="text-2xl font-bold w-full"
                  style={{ color: "#727A99" }}
                >
                  {t("prescription")} |{" "}
                  <span style={{ color: "#E3506B" }}>
                    {selectedPatient.firstName + " " + selectedPatient.lastName}
                  </span>
                </span>
                {isEditModeActive ? (
                  <div className="flex align-items-center justify-content-end gap-3">
                    <Button
                      style={{ borderRadius: "10px", height: "3rem" }}
                      link
                      className="p-0"
                      onClick={() => {}}
                    >
                      <span
                        className="flex justify-content-center align-items-center gap-2 font-semibold"
                        style={{
                          borderBottom: "1px solid rgba(99, 131, 244, 1)",
                          width: "100%",
                          color: "rgba(99, 131, 244, 1)",
                          fontSize: "1rem",
                        }}
                        onClick={handleSaveEdit}
                      >
                        <i className="pi pi-save"></i>
                        {t("save")}
                      </span>
                    </Button>
                    <Button
                      style={{ borderRadius: "10px", height: "3rem" }}
                      link
                      className="p-0"
                      onClick={() => {
                        setIsEditModeActive(false);
                      }}
                    >
                      <span
                        className="flex justify-content-center align-items-center gap-2 font-semibold"
                        style={{
                          borderBottom: "1px solid rgba(99, 131, 244, 1)",
                          width: "100%",
                          color: "rgba(99, 131, 244, 1)",
                          fontSize: "1rem",
                        }}
                        onClick={() => {
                          setSelectedExercise(null);
                          setIsCollapsedDetails(false);
                          setIsEditModeActive(false);
                        }}
                      >
                        <i className="pi pi-times"></i>
                        {t("cancel")}
                      </span>
                    </Button>
                  </div>
                ) : (
                  <Button
                    style={{ borderRadius: "10px", height: "3rem" }}
                    link
                    className="flex align-items-center justify-content-end w-full"
                    onClick={() => {
                      setTempEditedExercises(selectedExercises);
                      setIsEditModeActive(true);
                    }}
                  >
                    <span
                      className="flex align-items-center gap-2 font-semibold"
                      style={{
                        borderBottom: "1px solid rgba(99, 131, 244, 1)",
                        color: "rgba(99, 131, 244, 1)",
                        fontSize: "1rem",
                      }}
                    >
                      <i className="pi pi-pencil"></i>
                      {t("editPanel")}
                    </span>
                  </Button>
                )}
              </div>
              <div>
                {(isEditModeActive ? tempEditedExercises : selectedExercises)?.map(
                  (exercise: any, index: number) => (
                    <WizardSelectedExercisesItemTemplate
                      t={t}
                      index={index}
                      exercise={exercise}
                      handleDelete={() => handleDelete(exercise)}
                      setSelectedExercise={setSelectedExercise}
                      isEditModeActive={isEditModeActive}
                      setExerciseVideoDialogVisible={
                        setExerciseVideoDialogVisible
                      }
                      setSelectedExerciseForVideo={setSelectedExerciseForVideo}
                      setIsCollapsedDetails={setIsCollapsedDetails}
                      moveCard={moveCard}
                    />
                  )
                )}
              </div>
            </div>
          </div>

          <div
            className="flex gap-3 align-items-center"
            style={{
              backgroundColor: "#D4DDFF",
              marginTop: "auto",
              flexShrink: 0,
            }}
          >
            <div className="flex w-full flex-column gap-1">
              <label htmlFor="planName" style={{ color: "#727A99" }}>
                {t("carePlanName")} <span style={{ color: "#E3506B" }}>*</span>
              </label>
              <InputText
                className="care-plan-name-inputtext"
                value={carePlanName}
                onChange={handleCarePlanName}
                id="planName"
                placeholder={t("patientCarePlan")}
                style={{ borderRadius: "10px", border: "1px solid #9EA4B9" }}
                onInput={(e: any) => {
                  handleCarePlanName({
                    target: { value: e.currentTarget.value },
                  });
                }}
              />
            </div>
            <div className="flex flex-column gap-1 w-full">
              <label htmlFor="dateOfStart" style={{ color: "#727A99" }}>
                {t("dateOfStart")} <span style={{ color: "#E3506B" }}>*</span>
              </label>
              <Calendar
                className="add-exercise-dialog-calendar"
                value={dateOfStart}
                id="dateOfStart"
                onChange={handleDateOfStart}
                minDate={new Date()}
                maxDate={dateOfEnd}
              />
            </div>
            <div className="flex flex-column gap-1 w-full">
              <label htmlFor="dateOfEnd" style={{ color: "#727A99" }}>
                {t("dateOfEnd")} <span style={{ color: "#E3506B" }}>*</span>
              </label>
              <Calendar
                className="add-exercise-dialog-calendar"
                value={dateOfEnd}
                id="dateOfEnd"
                onChange={handleDateOfEnd}
                minDate={dateOfStart}
                maxDate={
                  new Date(new Date().getTime() + 90 * 24 * 60 * 60 * 1000)
                }
              />
            </div>
          </div>

          {isCollapsedDetails && selectedExercise && (
            <ExerciseEditSection
              t={t}
              selectedExercise={selectedExercise}
              setSelectedExercise={setSelectedExercise}
              editedExercises={editedExercises}
              setEditedExercises={setTempEditedExercises}
              isEditModeActive={isEditModeActive}
              setIsCollapsedDetails={setIsCollapsedDetails}
            />
          )}

          <div
            className="flex gap-3 align-items-center"
            style={{
              backgroundColor: "#D4DDFF",
              paddingTop: "1rem",
              marginTop: "auto",
              height: "4rem",
              flexShrink: 0,
            }}
          >
            <div
              className="total-exercises-badge"
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "0.5rem",
              }}
            >
              <span>{t("totalExercise")}</span>
              <span className="font-bold">|</span>
              <span className="total-exercises-count">
                {selectedExercises.length}
              </span>
            </div>

            <Button
              label={t("approve")}
              className="p-3 w-full"
              style={{
                backgroundColor: "#6383F4",
                color: "#FFFFFF",
                borderRadius: "12px",
                border: "none",
                height: "100%",
              }}
              disabled={
                selectedExercises.length === 0 ||
                !carePlanName ||
                !dateOfStart ||
                !dateOfEnd ||
                isPendingAddPlan ||
                isEditModeActive
              }
              onClick={handleApprovePrescription}
              loading={isPendingAddPlan}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default Step4;
